import type { ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponEventCommentProps = {
  className?: string;
  eventComment?: string;
};

/**
 * Component to display the event comment for a given coupon.
 *
 * @param root0 CouponEventComment input props
 * @param root0.className the classes for the div
 * @param root0.eventComment the comment to display
 * @returns undefined if eventcomment isnt given otherwise a div with the event comment
 */
export default function CouponEventComment({ className, eventComment }: CouponEventCommentProps): ReactNode {
  if (!eventComment || eventComment.length === 0) {
    return undefined;
  }

  return <div className={cn('text-important mt-1.5 text-sm lg:text-base', className)}>{eventComment}</div>;
}
